import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _toConsumableArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits"; //@ts-check

import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import OperatorSelect from './OperatorSelect';
import DataTree from '../../lab/DataTree';
import { DialogContent, FormLabel } from '@material-ui/core';
import { parseExpression, getExpression, conditions, isAdvancedExpression } from './xPathUtil';
import DataTreeSelect from '../../lab/DataTree/Select';
import WindowPanel from '../../modal/Window';
import request from '../../utils/request';
import getElementNode from '../DataTree/json2tree';
/**
 * @extends {React.Component<import('./types').XPathDialogProps  & import('@material-ui/core').WithStyles<typeof styles, true>> }
 */

var XPathDialog =
/*#__PURE__*/
function (_React$Component) {
  _inherits(XPathDialog, _React$Component);

  function XPathDialog(props) {
    var _this;

    _classCallCheck(this, XPathDialog);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(XPathDialog).call(this, props));

    _this.loadFileTree = function (schema) {
      var tree = getElementNode(schema);

      var getDescendants = function getDescendants(node) {
        var indent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        node.indent = indent;

        if (node.children) {
          return [node].concat(_toConsumableArray(node.children.flatMap(function (child) {
            return getDescendants(child, indent + 1);
          })));
        }

        return [node];
      };

      var nodeList = getDescendants(tree);

      _this.setState(function (_ref) {
        var field = _ref.field;
        return {
          items: nodeList,
          isLoading: false,
          advanced: field && !nodeList.find(function (x) {
            return x.xpath === field;
          })
        };
      });
    };

    _this.onDataError = function () {
      _this.setState({
        hasError: true,
        isLoading: false
      });
    };

    _this.onChangeOperator = function (conditionIndex) {
      return _this.setState({
        conditionIndex: conditionIndex
      });
    };

    _this.onChangeSecondOperand = function (e) {
      return _this.setState({
        secondOperand: e.target.value
      });
    };

    _this.handleTreeSelectionChange = function (node) {
      _this.setState(function () {
        var newState = {
          field: node.xpath
        };
        if (_this.state.advanced) newState.expression = (_this.state.expression || '') + node.xpath;
        return newState;
      });
    };

    _this.handleFieldChange = function (e) {
      _this.setState(function () {
        return {
          field: e.target.value
        };
      });
    };

    _this.getExpression = function () {
      var _this$state = _this.state,
          advanced = _this$state.advanced,
          expression = _this$state.expression,
          conditionIndex = _this$state.conditionIndex,
          field = _this$state.field,
          secondOperand = _this$state.secondOperand;
      if (advanced) return expression;
      if (!_this.props.isCondition) return field;
      var selectedCondition = conditions[conditionIndex];
      return getExpression(selectedCondition, field, secondOperand);
    };

    _this.handleToggleAdvanced = function () {
      _this.setState(function () {
        var newState = {
          advanced: !_this.state.advanced
        };
        newState.expression = _this.getExpression();
        return newState;
      });
    };

    _this.handleChangeExpression = function (e) {
      _this.setState({
        expression: e.target.value
      });
    };

    _this.onOK = function () {
      _this.props.onChange(_this.getExpression());
    };

    var value = props.value,
        isCondition = props.isCondition;
    var state = {
      items: [],
      isLoading: true,
      field: value,
      conditionIndex: 1,
      secondOperand: '',
      advanced: false,
      expression: value
    };

    if (value) {
      if (isCondition) {
        var parsedExpression = parseExpression(value); // TODO: go to advanced

        if (parsedExpression) {
          state = _objectSpread({}, state, {
            field: parsedExpression.FirstOperator,
            conditionIndex: conditions.indexOf(parsedExpression.Condition),
            secondOperand: parsedExpression.SecondOperator,
            advanced: false
          });
        } else {
          state.advanced = true;
        }
      } else if (isAdvancedExpression(value)) {
        state.advanced = true;
      }
    }

    _this.state = state;
    return _this;
  }

  _createClass(XPathDialog, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          workspace = _this$props.workspace,
          path = _this$props.path;
      request({
        url: "/backend/outputelement?workspace=".concat(encodeURIComponent(workspace), "&filepath=").concat(encodeURIComponent(path))
      }).then(this.loadFileTree, this.onDataError);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          classes = _this$props2.classes,
          workspace = _this$props2.workspace,
          path = _this$props2.path,
          theme = _this$props2.theme,
          onClose = _this$props2.onClose,
          title = _this$props2.title,
          isCondition = _this$props2.isCondition,
          rest = _objectWithoutProperties(_this$props2, ["classes", "workspace", "path", "theme", "onClose", "title", "isCondition"]);

      var _this$state2 = this.state,
          conditionIndex = _this$state2.conditionIndex,
          secondOperand = _this$state2.secondOperand,
          field = _this$state2.field,
          advanced = _this$state2.advanced,
          expression = _this$state2.expression,
          isLoading = _this$state2.isLoading,
          hasError = _this$state2.hasError,
          items = _this$state2.items;
      var dialogTitle = title || (isCondition ? 'Condition' : 'Expression');
      return React.createElement(WindowPanel, Object.assign({
        onClose: onClose,
        header: dialogTitle,
        style: {
          width: 600
        },
        footerButtons: {
          submit: {
            children: 'Insert',
            onClick: this.onOK,
            disabled: !this.getExpression()
          },
          leftAction: advanced ? null : {
            children: 'Advanced Expression',
            onClick: this.handleToggleAdvanced
          }
        },
        content: React.createElement(DialogContent, null, !advanced && React.createElement(Grid, {
          container: true,
          direction: "column",
          className: classes.root,
          spacing: 2
        }, React.createElement(Grid, {
          item: true
        }, React.createElement(FormLabel, null, "Field"), React.createElement(DataTreeSelect, {
          workspace: workspace,
          path: path,
          onChange: this.handleFieldChange,
          value: field,
          isLoading: isLoading,
          hasError: false,
          items: items
        })), isCondition && React.createElement(React.Fragment, null, React.createElement(Grid, {
          item: true,
          className: classes.gridWidth
        }, React.createElement(FormLabel, null, "Operator"), React.createElement(OperatorSelect, {
          onChange: this.onChangeOperator,
          value: conditionIndex
        })), conditionIndex && conditions[conditionIndex].OperatorsNumber === 2 && !conditions[conditionIndex].SameOperators && React.createElement(Grid, {
          item: true,
          className: classes.gridWidth
        }, React.createElement(FormLabel, null, "Value"), React.createElement(TextField, {
          fullWidth: true,
          onChange: this.onChangeSecondOperand,
          value: secondOperand
        })))), advanced && React.createElement(Grid, {
          container: true,
          direction: "column",
          className: classes.root,
          spacing: 2
        }, React.createElement(Grid, {
          item: true
        }, React.createElement(FormLabel, null, "Expression"), React.createElement(TextField, {
          fullWidth: true,
          multiline: true,
          rows: "4",
          onChange: this.handleChangeExpression,
          value: expression || ''
        })), React.createElement(Grid, {
          item: true
        }, React.createElement(FormLabel, null, "Fields"), React.createElement("div", {
          className: classes.treeWrapper
        }, React.createElement(DataTree, {
          workspace: workspace,
          path: path,
          onChange: this.handleTreeSelectionChange,
          value: field
        })))))
      }, rest));
    }
  }]);

  return XPathDialog;
}(React.Component);

var styles = {
  root: {},
  treeWrapper: {
    overflowY: 'auto',
    maxHeight: 'calc(100vh - 420px)',
    minHeight: 200
  },
  //an issue on Chrome causes the Grid items to resize on hover. Please consult item 105110 for reference.
  gridWidth: {
    width: '100%'
  }
};
XPathDialog.defaultProps = {
  value: '',
  title: '',
  isCondition: false
};
export default withStyles(styles, {
  withTheme: true,
  name: 'ECXPathDialog'
})(XPathDialog);